import { Breakpoints, Layout, LayoutRowGap, styled, ThemeProvider } from '@volkswagen-onehub/components-core';
import React from 'react';
import { bonoPosventaBackgroundColor } from '../../../../../../../helpers/color-tokens';
import { BonoCardBackground } from '../../../../shared/ui/bono-card-backgound';
import { PdfBonoPosventaCardC1 } from './pdf-bono-posventa-card-c1';
import { PdfBonoPosventaCardC2 } from './pdf-bono-posventa-card-c2';

const BonoCardBackgroundPdfBonoPosventa = styled(BonoCardBackground)`
	padding-bottom: var(--size-dynamic0300);
`;

export const PdfBonoPosventaCard: React.FC<{
	dineroHucha: string;
}> = ({ dineroHucha }) => {
	return (
		<BonoCardBackgroundPdfBonoPosventa
			bgColor={bonoPosventaBackgroundColor}
			stretchContent
			verticalAlign="center"
			horizontalAlign="center"
			data-testid="bono-posventa-card-container"
			wrap={{
				[Breakpoints.default]: 'never',
			}}
		>
			<ThemeProvider theme="inverted">
				<Layout
					data-testid="hucha-card-layout"
					rowGap={LayoutRowGap.dynamic0130}
					appearance={{
						[Breakpoints.default]: [
							{ name: 'bono-posventa-popup-card-c2', columns: 11 },
							{ name: '.', columns: 2 },
							{ name: 'bono-posventa-popup-card-c3', columns: 11 },
						],
					}}
				>
					<PdfBonoPosventaCardC1 />
					<PdfBonoPosventaCardC2 dineroHucha={dineroHucha} />
				</Layout>
			</ThemeProvider>
		</BonoCardBackgroundPdfBonoPosventa>
	);
};
